import { LinkButton } from '@/shared/ui/Button/LinkButton'
import { PillButtonSecondary } from '@/shared/ui/Button/PillButtonSecondary'
import { PrimaryButton } from '@/shared/ui/Button/PrimaryButton'
import {
  ModalClose,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalOverlay,
  ModalPortal,
  ModalTitle,
} from '@/shared/ui/Modals/styles'
import { Text } from '@/shared/ui/Typography'
import { IconCheck, IconX } from '@tabler/icons-react'
import Image from 'next/image'
import attentionIcon from 'public/assets/images/attention-icon.svg'

export function CancelModal({
  onConfirm,
  onDismiss,
}: {
  onConfirm: () => void
  onDismiss?: () => void
}) {
  return (
    <ModalPortal>
      <ModalOverlay />
      <ModalContent>
        <ModalClose asChild>
          <PillButtonSecondary variant="default">
            <IconX />
          </PillButtonSecondary>
        </ModalClose>
        <header>
          <Image
            src={attentionIcon}
            width={72}
            height={72}
            quality={100}
            alt=""
          />
          <Text size="body3">Atenção!</Text>
        </header>
        <div>
          <ModalTitle>Tem certeza que deseja cancelar?</ModalTitle>
          <ModalDescription>Seu progresso não será salvo.</ModalDescription>
        </div>

        <ModalFooter variant="cancel">
          <ModalClose asChild>
            <LinkButton variant="neutral" type="button" onClick={onDismiss}>
              Cancelar
            </LinkButton>
          </ModalClose>
          <PrimaryButton type="button" variant="error" onClick={onConfirm}>
            Confirmar
            <IconCheck />
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </ModalPortal>
  )
}
